import { useEffect, useRef } from "react";
import Router from "./routes";
import ThemeProvider from "./theme";
import { useDispatch, useSelector } from "react-redux";
import { handleChat, setLastReceivedMessage } from "./components/Conversation/contactSlice";
import { useSocket } from "./contexts/SocketContext";

function AppContent() {
  const dispatch = useDispatch();
  const { selectedContact } = useSelector((state) => state.contactList);
  const selectedContactRef = useRef(selectedContact);
  const socket = useSocket();

  useEffect(() => {
    selectedContactRef.current = selectedContact;
  }, [selectedContact]);

  useEffect(() => {
    if (!socket) return;

    socket.on("connect", () => { });

    socket.on("data", (data) => {
      if (!data) return;
      const formattedMessage = {
        ...data,
        type: data.wa_type,
      };

      dispatch(setLastReceivedMessage(formattedMessage));

      const currentSelectedContact = selectedContactRef.current;

      const sanitize = (num) => String(num || "").replace(/\D/g, "");

      const match1 = sanitize(currentSelectedContact?.wa_number) === sanitize(data.from);
      const match2 = sanitize(currentSelectedContact?.num) === sanitize(data.from);

      if (
        currentSelectedContact &&
        (match1 || match2)
      ) {
        dispatch(handleChat(formattedMessage));
      }
    });

    socket.on("logged_out", (data) => {
      const currentUsername = localStorage.getItem("username");
      if (data.username === currentUsername) {
        localStorage.clear();
        const BASENAME = process.env.REACT_APP_BASENAME || "";
        window.location.href = `${BASENAME}/auth/login`;
      }
    });

    return () => {
      socket.off("connect");
      socket.off("data");
      socket.off("logged_out");
    };
  }, [dispatch, socket]);

  return (
    <ThemeProvider>
      <Router />
    </ThemeProvider>
  );
}

function App() {
  return (
    <AppContent />
  );
}

export default App;
